export default {
    dataApi: "https://api.catalogueoflife.org/"
}